/**
 * 门店管理  用户余额管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户余额管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.mobile" placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select size="small" v-model="formInline.status" placeholder="请选择">
          <el-option v-for="type in userType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="info" icon="el-icon-refresh" @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column sortable prop="id" label="用户ID" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="username" label="用户昵称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="mobile" label="手机号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="status_txt" label="用户状态" width="140" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag
            :type="getStatusTag(scope.row.status_txt)"
            :disable-transitions="false"
          >
            {{ scope.row.status_txt }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createtime_txt" label="创建时间" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="open(scope.$index, scope.row)">查询余额</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

  </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import {userBalance, userList} from "../../api/shop";
export default {
  data() {
    return {
      loading: false, //是显示加载
      title: '预览',
      userType: [
        { key: '请选择', value: 0 },
        { key: '正常', value: 'normal' },
        { key: '异常', value: 'formal' },
      ],

      formInline: {
        page: 1,
        limit: 10,
        mobile: '',
        status: '',
        org_id: this.$globalConfig.orgId,
      },

      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getStatusTag(status) {
      switch (status) {
        case '正常':
          return 'success'
        case '异常':
          return 'danger'
        default:
          return 'info'
      }
    },
    open:function (index, row){
      this.loading = true
      const param = {
        'user_id': row.id
      };
      userBalance(param)
        .then(res => {
          this.loading = false
          if (res.code !== 1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.$alert('余额：'+res.data, '会员余额', {
              confirmButtonText: '关闭',
            });

          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },

    // 获取用户列表
    getdata(parameter) {
      this.loading = true
      userList(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== 1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },

    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },

    // 重置表单
    resetForm() {
      this.formInline.page = 1
      this.formInline.limit = 10
      this.formInline.mobile = ''
      this.formInline.status = ''
      this.getdata(this.formInline)
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/shop/Balance.vue